import React, { PropsWithChildren } from 'react';

import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

import FlexContainer from 'client/app/apps/disco-prototype/components/FlexContainer';
import PageFooter from 'client/app/apps/disco-prototype/components/PageFooter';
import PageHeader from 'client/app/apps/disco-prototype/components/PageHeader';
import { discoPrototypeRoutes } from 'client/app/apps/disco-prototype/DiscoPrototypeRouter';

const Layout = ({ children }: PropsWithChildren) => {
  return (
    <FlexContainer direction="column">
      <PageHeader title="Define Liquid Set" />
      {children}
      <PageFooter>
        <Button component={Link} to={discoPrototypeRoutes.root.getPath()}>
          Back
        </Button>
      </PageFooter>
    </FlexContainer>
  );
};

export default Layout;
